import { SET_CUTOFFS } from './types';

export const setCutoffs = cutoffs => ({ type: SET_CUTOFFS, cutoffs });
